/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/address';
import '../../../legalentities/model/model';
import './business';
import './controlling_individual';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "ApplicationFlowUpdate": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "individual": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate.IndividualUpdate",
                        "id": 2,
                        "rule": "optional"
                      },
                      "business": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate.BusinessUpdate",
                        "id": 3,
                        "rule": "optional"
                      },
                      "addControllingIndividuals": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate.ControllingIndividualAdd",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "updateControllingIndividuals": {
                        "type": ".squareup.sfs.external.models.ApplicationFlowUpdate.ControllingIndividualUpdate",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "removeControllingIndividualIds": {
                        "type": "string",
                        "id": 6,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "BusinessUpdate": {
                        "fields": {
                          "businessName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "address": {
                            "type": ".squareup.connect.v2.resources.Address",
                            "id": 2,
                            "rule": "optional"
                          },
                          "businessType": {
                            "type": ".squareup.legalentities.model.Business.Structure.Type",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ein": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "llcTaxClassification": {
                            "type": ".squareup.sfs.external.models.Business.LlcTaxClassification",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "IndividualUpdate": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "givenName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "surname": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "address": {
                            "type": ".squareup.connect.v2.resources.Address",
                            "id": 3,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "ssn": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "backupWithholdingStatus": {
                            "type": ".squareup.sfs.external.models.ApplicationFlowUpdate.IndividualUpdate.BackupWithholdingStatus",
                            "id": 7,
                            "rule": "optional"
                          },
                          "isManager": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "hasSignificantOwnership": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BackupWithholdingStatus": {
                            "values": {
                              "BW_STATUS_DO_NOT_USE": 0,
                              "NO_WITHHOLDING": 1,
                              "HAS_WITHHOLDING": 2
                            }
                          }
                        }
                      },
                      "ControllingIndividualAdd": {
                        "fields": {
                          "givenName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "surname": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "address": {
                            "type": ".squareup.connect.v2.resources.Address",
                            "id": 3,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "isManager": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "hasSignificantOwnership": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "ssn": {
                            "type": ".squareup.sfs.external.models.Ssn",
                            "id": 5
                          }
                        },
                        "nested": {
                          "government_id": {
                            "oneof": ["ssn"]
                          }
                        }
                      },
                      "ControllingIndividualUpdate": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "givenName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "surname": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "address": {
                            "type": ".squareup.connect.v2.resources.Address",
                            "id": 4,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "isManager": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "hasSignificantOwnership": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "ssn": {
                            "type": ".squareup.sfs.external.models.Ssn",
                            "id": 6
                          }
                        },
                        "nested": {
                          "government_id": {
                            "oneof": ["ssn"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate?.nested?.BusinessUpdate && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate?.nested?.IndividualUpdate && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate?.nested?.IndividualUpdate?.nested?.BackupWithholdingStatus && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate?.nested?.ControllingIndividualAdd && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.ApplicationFlowUpdate?.nested?.ControllingIndividualUpdate) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Writeable fields for an SFS ApplicationFlow.
 * --
 *
 * SOURCE ApplicationFlowUpdate @ squareup/sfs/external/models/application_flow_update.proto at 16:1
 */
export const ApplicationFlowUpdate = $root.lookupType('squareup.sfs.external.models.ApplicationFlowUpdate');
fixType(ApplicationFlowUpdate, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ApplicationFlowUpdate);
/**
 * SOURCE BusinessUpdate @ squareup/sfs/external/models/application_flow_update.proto at 17:3
 */
ApplicationFlowUpdate.BusinessUpdate = $root.lookupType('squareup.sfs.external.models.ApplicationFlowUpdate.BusinessUpdate');
fixType(ApplicationFlowUpdate.BusinessUpdate);
Builder.createAndAttachToType(ApplicationFlowUpdate.BusinessUpdate);
/**
 * SOURCE IndividualUpdate @ squareup/sfs/external/models/application_flow_update.proto at 47:3
 */
ApplicationFlowUpdate.IndividualUpdate = $root.lookupType('squareup.sfs.external.models.ApplicationFlowUpdate.IndividualUpdate');
fixType(ApplicationFlowUpdate.IndividualUpdate);
Builder.createAndAttachToType(ApplicationFlowUpdate.IndividualUpdate);
/**
 * SOURCE BackupWithholdingStatus @ squareup/sfs/external/models/application_flow_update.proto at 48:5
 */
ApplicationFlowUpdate.IndividualUpdate.BackupWithholdingStatus = $root.lookupEnum('squareup.sfs.external.models.ApplicationFlowUpdate.IndividualUpdate.BackupWithholdingStatus').values;
/**
 * SOURCE ControllingIndividualAdd @ squareup/sfs/external/models/application_flow_update.proto at 101:3
 */
ApplicationFlowUpdate.ControllingIndividualAdd = $root.lookupType('squareup.sfs.external.models.ApplicationFlowUpdate.ControllingIndividualAdd');
fixType(ApplicationFlowUpdate.ControllingIndividualAdd);
Builder.createAndAttachToType(ApplicationFlowUpdate.ControllingIndividualAdd);
/**
 * SOURCE ControllingIndividualUpdate @ squareup/sfs/external/models/application_flow_update.proto at 134:3
 */
ApplicationFlowUpdate.ControllingIndividualUpdate = $root.lookupType('squareup.sfs.external.models.ApplicationFlowUpdate.ControllingIndividualUpdate');
fixType(ApplicationFlowUpdate.ControllingIndividualUpdate);
Builder.createAndAttachToType(ApplicationFlowUpdate.ControllingIndividualUpdate);